import React, { useMemo, useState } from 'react';
import cn from 'classnames';

import { useTranslation } from 'react-i18next';

import SidebarItem from '@shared/SidebarItem/SidebarItem';

import { List } from '@mui/material';

import { CdnIcon } from '@shared/ui';

import { ModalX, Header, IconButton, BackwardButton } from '../BaseComponents';

import { isRouteSelected } from '../Account/utils';
import { PathRoute, Route } from '../Account/types';

import { useTheme } from '../theme';

interface Props {
	className?: string;
	title?: string;
	routes: Route[];
	selectedRoute: string;
	onBack?: () => void;
}

const MobileSidebar: React.FunctionComponent<Props> = ({
	className,
	title: titleProp,
	routes,
	selectedRoute,
	onBack
}) => {
	const [isOpenedMenu, setOpenedMenu] = useState(false);

	const { MobileSidebar: css } = useTheme('MobileSidebar');
	const { t } = useTranslation('Account');

	const title = useMemo(() => {
		if (titleProp) {
			return titleProp;
		}

		return routes.find(item => (item as PathRoute)?.pathname === selectedRoute)?.title;
	}, [routes, selectedRoute, titleProp]);

	return (
		<>
			<Header
				className={cn(css.mobileSidebar__header, className)}
				left={
					<div className={css.mobileSidebar__header_title}>
						{onBack && (
							<BackwardButton className={css.mobileSidebar__header_backwardButton} onClick={onBack} />
						)}

						{t(title)}
					</div>
				}
				right={
					<IconButton
						className={css.mobileSidebar__header_moreButton}
						onClick={() => setOpenedMenu(!isOpenedMenu)}
					>
						<CdnIcon icon="Action/More" />
					</IconButton>
				}
				equalSlotsBasis={false}
				showEmptySlots={false}
			/>

			<ModalX
				classes={{
					top_wrapper: css.mobileSidebar,
					closeButton: css.mobileSidebar__closeButton
				}}
				isOpen={isOpenedMenu}
				onClose={() => setOpenedMenu(false)}
				noPadding
			>
				<div className={css.mobileSidebar__modalTitle}>{t('Cabinet menu')}</div>

				<List className={css.mobileSidebar__items}>
					{routes.map(route => (
						<SidebarItem
							key={route.title}
							route={route}
							isSelected={isRouteSelected(route, selectedRoute)}
							onClickCallback={() => setOpenedMenu(false)}
						/>
					))}
				</List>
			</ModalX>
		</>
	);
};

export default MobileSidebar;
